import { Tooltip, Typography } from 'antd'
import { format, formatDistanceToNow, parseISO } from 'date-fns'

/** Relative time of a hardware measurement, the exact one on hover. */
export function MeasuredAt({ at, prefix }: { at: string; prefix: string }) {
  const date = parseISO(at)
  return (
    <Tooltip title={format(date, 'PPpp O')} trigger={['hover', 'focus']}>
      <Typography.Text type="secondary" tabIndex={0}>
        {prefix} {formatDistanceToNow(date, { addSuffix: true })}
      </Typography.Text>
    </Tooltip>
  )
}
